import { render, staticRenderFns } from "./ChaoFilm.vue?vue&type=template&id=0926386e&scoped=true&lang=html&"
import script from "./ChaoFilm.vue?vue&type=script&lang=js&"
export * from "./ChaoFilm.vue?vue&type=script&lang=js&"
import style0 from "./ChaoFilm.vue?vue&type=style&index=0&id=0926386e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926386e",
  null
  
)

export default component.exports